import type { ListFavoriteTimetableParams } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

// お気に入り施設のプログラムを日付ごと（{ [YYYYMMDD]: FavoriteTimetable[] }）に取得する
export const useFavoriteTimetables = (
  params?: ListFavoriteTimetableParams,
  enabled = true,
  options: SWRConfiguration = {},
) => {
  const client = useGyymClient()
  const { isLoggedIn, isEmailVerified } = useAuthUser()

  return useGyymSWR(
    isLoggedIn && isEmailVerified && enabled
      ? [client.user.favorites.listTimetables, params]
      : null,
    options,
  )
}
